if (typeof IntersectionObserver === 'undefined') {
    require('intersection-observer');
}

import lazyLoad from "./LazyLoadLib";

export default function (items: string|NodeListOf<Element>): void
{
    if (typeof items === 'string') {
        items = document.querySelectorAll(items);
    }

    new lazyLoad(items.length > 0 ? items : null);
}
